import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../../components';
import { InsuranceRateCoverage } from '../../../../generated/graphql';
import { displayRate, SMTailwindMinPixelBreakpointWidth } from '../../../../util';
import { useMediaQuery } from '@mui/material';

interface InsuranceCalculationBreakdownProps {
  dividendElement?: JSX.Element;
  divisorElement?: JSX.Element;
  insuranceRateCoverage: InsuranceRateCoverage;
}

export const InsuranceCalculationBreakdown: FC<InsuranceCalculationBreakdownProps> = ({
  divisorElement,
  dividendElement,
  insuranceRateCoverage,
}) => {
  const { t: tInsurance } = useTranslation('insurance');
  const isSmall = useMediaQuery(`(max-width: ${SMTailwindMinPixelBreakpointWidth}px)`);

  return isSmall ? (
    <div className="mb-5 grid grid-cols-[calc(100vw-184px)_auto_auto] items-center">
      <div className="flex flex-col items-start">
        <div className="mb-2">{dividendElement}</div>
        <div className="bg-palette-600 w-full h-[2px]"></div>
        <div className="mt-2">{divisorElement}</div>
      </div>

      <div className="flex justify-end mr-2">
        <Icon icon={'equals'} className="text-palette-600" />
      </div>

      <div className="text-right w-[15px] ml-2">
        <p className="text-[24px] font-medium leading-[24px] text-white">
          {displayRate(Math.max(Math.min(insuranceRateCoverage.overallCoverage, 1), 0))}
        </p>
      </div>
    </div>
  ) : (
    <div
      className="mb-5 grid w-[508px] grid-flow-col items-end"
      style={{ gridTemplateColumns: '183px 1fr 227px 1fr 70px' }}
    >
      {dividendElement}
      <Icon icon={'divisionSlash'} className="mx-auto text-palette-600" />
      <div className="ml-[35px]">{divisorElement}</div>
      <Icon icon={'equals'} className="mx-auto mb-[6px] text-palette-600" />
      <div className="text-right">
        <p className="mb-[2px] text-[13px] font-medium leading-[13px] text-gray-light opacity-70">
          {tInsurance('calculation-breakdown-rate')}
        </p>
        <p className="text-[24px] font-medium leading-[24px] text-white">
          {displayRate(Math.max(Math.min(insuranceRateCoverage.overallCoverage, 1), 0))}
        </p>
      </div>
    </div>
  );
};
